import {
    CONFIRMED_CREATE_PLAN_ACTION,
    CONFIRMED_DELETE_PLAN_ACTION,
    CONFIRMED_EDIT_PLAN_ACTION,
    CONFIRMED_GET_PLANS,
    CREATE_PLAN_ACTION,    
    CREATE_PLAN_ERROR_ACTION,
    CLEAR_PLAN_ERROR,
    LOADING_PLANS,
    LOADING_TOGGLE_ACTION
} from '../actions/PlanTypes';

const initialState = {
    plans: [],
    loading: false,
    createPlanError: {}
};

export default function PlanReducer(state = initialState, actions) {
    if (actions.type === CREATE_PLAN_ACTION) { 
        return {
            ...state,
            plans: [...state.plans],
        };
    }

    if (actions.type === CONFIRMED_DELETE_PLAN_ACTION) {
        const plans = state.plans.filter(plan => plan.id !== actions.payload);
        return {
            ...state,
            plans,
        };
    }

    if (actions.type === CONFIRMED_EDIT_PLAN_ACTION) {
        const plans = state.plans.map(plan => 
            plan.id === actions.payload.id ? actions.payload : plan
        );
        return {
            ...state,
            plans,
        };
    }

    if (actions.type === CONFIRMED_CREATE_PLAN_ACTION) {
        return {
            ...state,
            plans: [...state.plans, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_PLANS) {
        return {
            ...state,
            plans: actions.payload,
        };
    }

    if (actions.type === LOADING_PLANS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_PLAN_ERROR_ACTION) {
        return {
            ...state,
            createPlanError: actions.payload,
        };
    }

    if (actions.type === CLEAR_PLAN_ERROR) {
        return {
            ...state,
            createPlanError: {},
        };
    }
    if (actions.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            loading: actions.payload,
        };
    }
    return state;
}
